import { useMyOrders } from "api/Client/product";
import Container from "components/ClientLayoutPages/Container/Container";
import MyOrderModal from "components/Modal/Client/MyOrderModal/MyOrderModal";
import SkeletonMyOrder from "components/SkeletonList/SkeletonMyOrder";
import useParam from "Hooks/useParam";
import { useEffect, useState } from "react";
import { FaCheck, FaTimes, FaClock } from "react-icons/fa";
import { MdOutlineInbox, MdReceiptLong } from "react-icons/md";
import { SlCalender } from "react-icons/sl";

export default function MyOrders() {
  // ... (نفس الـ Logic الخاص بك دون تغيير) ...
  const orderId = useParam("orderId");
  const [openMyOrderModal, setOpenMyOrderModal] = useState(false);
  const [currentId, setCurrentId] = useState(orderId || null);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit] = useState(9);
  const [searchValue] = useState("");
  const [orderState] = useState("");

  const {
    data: myOrders,
    isFetching: myOrdersIsLoading,
    isSuccess: myOrdersIsSuccess,
  } = useMyOrders(limit, pageNumber, searchValue, orderState);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageNumber]);

  return (
    <Container title={`حجوزاتي`}>
      <div className="min-h-[60vh] font-[Tajawal] py-6" dir="rtl">
        {myOrdersIsLoading && <SkeletonMyOrder number={6} />}

        {/* حالة عدم وجود حجوزات */}
        {!myOrdersIsLoading &&
          myOrdersIsSuccess &&
          myOrders?.data?.orders.length === 0 && (
            <div className="flex flex-col items-center justify-center text-center py-20">
              <div className="mb-6 flex items-center justify-center h-24 w-24 rounded-[2rem] bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 shadow-inner">
                <MdOutlineInbox className="text-5xl text-gray-300" />
              </div>
              <h3 className="text-xl font-bold text-gray-700 dark:text-gray-200">
                صندوق الحجوزات فارغ
              </h3>
              <p className="mt-2 text-sm text-gray-400">
                ستظهر جميع طلباتك هنا بمجرد البدء بالتسوق
              </p>
            </div>
          )}

        {/* شبكة الطلبات */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {!myOrdersIsLoading &&
            myOrdersIsSuccess &&
            myOrders.data?.orders.map((item) => (
              <div
                key={item.id}
                onClick={() => {
                  setCurrentId(item.id);
                  setOpenMyOrderModal(true);
                }}
                className="group relative overflow-hidden rounded-[2rem] p-6 transition-all duration-500
                         bg-gray-100 dark:bg-white/5 border border-white dark:border-white/10 
                         hover:border-mainLight/40 hover:-translate-y-2 hover:shadow-2xl active:scale-95 cursor-pointer"
              >
                {/* شارة الحالة (Status Badge) */}
                <div className="flex justify-between items-start mb-6">
                  <div className="flex flex-col">
                    <span className="text-[10px] uppercase tracking-widest text-gray-400 font-bold mb-1">
                      رقم الفاتورة
                    </span>
                    <span className="text-sm font-bold text-mainLight">
                      #{item.order_number}
                    </span>
                  </div>
                  <StatusBadge state={item.status} />
                </div>

                {/* تفاصيل المبالغ بتنسيق عصري */}
                <div className="space-y-4 mb-6">
                  <div className="flex justify-between items-end">
                    <span className="text-xs text-gray-500 dark:text-gray-400 font-medium italic">
                      إجمالي الحجز
                    </span>
                    <div className="text-left">
                      <span className="text-2xl font-bold text-gray-800 dark:text-white leading-none">
                        {Number(Math.abs(item.total_amount)).toLocaleString()}
                      </span>
                      <span className="text-[10px] text-mainLight font-bold mr-1">
                        USD
                      </span>
                    </div>
                  </div>

                  <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-gray-200 dark:via-white/10 to-transparent" />

                  <div className="flex justify-between items-center text-xs">
                    <div className="flex items-center gap-2 text-gray-500">
                      <SlCalender className="text-mainLight" />
                      <span>{item.created_at}</span>
                    </div>
                    <div className="font-bold text-gray-700 dark:text-gray-300 flex gap-1">
                      مدفوع:{" "}
                      <div className="flex gap-2" dir="ltr">
                        <span className="text-green-500">
                          {item.paid_amount}
                        </span>{" "}
                        <span className="text-green-500">{item.currency}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* زر تفاصيل مخفي يظهر عند الحوم */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-mainLight scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              </div>
            ))}
        </div>

        {/* الترقيم (Pagination) */}
        {myOrders?.data?.orders.length > 0 && (
          <div className="mt-12 flex flex-col items-center gap-4">
            <div className="flex items-center gap-4">
              <button
                disabled={pageNumber === 1}
                onClick={() => setPageNumber((prev) => prev - 1)}
                className="px-6 py-2 rounded-xl bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 text-sm font-bold disabled:opacity-30 transition-all hover:bg-mainLight hover:text-white"
              >
                السابق
              </button>
              <span className="text-xs font-bold text-gray-500">
                صفحة {pageNumber} من {myOrders?.data?.pagination?.last_page}
              </span>
              <button
                disabled={pageNumber >= myOrders?.data?.pagination?.last_page}
                onClick={() => setPageNumber((prev) => prev + 1)}
                className="px-6 py-2 rounded-xl bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 text-sm font-bold disabled:opacity-30 transition-all hover:bg-mainLight hover:text-white"
              >
                التالي
              </button>
            </div>
          </div>
        )}
      </div>

      {openMyOrderModal && (
        <MyOrderModal
          isOpen={openMyOrderModal}
          toggle={setOpenMyOrderModal}
          orderId={currentId}
          url={orderId}
        />
      )}
    </Container>
  );
}

// مكون صغير لحالة الطلب لتبسيط الكود الأساسي
function StatusBadge({ state }) {
  const config = {
    pending: {
      label: "انتظار",
      color: "text-gray-500 bg-gray-100",
      icon: <FaClock />,
    },
    processed: {
      label: "انتظار",
      color: "text-gray-500 bg-gray-100",
      icon: <FaClock />,
    },

    paid: {
      label: "مكتمل",
      color: "text-green-500 bg-green-500/10",
      icon: <FaCheck />,
    },
    cancelled: {
      label: "مرفوض",
      color: "text-red-500 bg-red-500/10",
      icon: <FaTimes />,
    },
    cancelled: {
      label: "ملغي",
      color: "text-red-500 bg-red-500/10",
      icon: <FaTimes />,
    },
  };

  const status = config[state] || config.pending;

  return (
    <div
      className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold uppercase ${status.color}`}
    >
      {status.icon}
      <span>{status.label}</span>
    </div>
  );
}
